module.exports = __webpack_public_path__ + "static/assets/69e482d167478834f045fa538d2e7eee.png";